import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { isAdminSelector, isSuperAdminUserSelector, selectUser } from "redux/slices/userSlice";
import { PATHS } from "../../util/appConstants";

export default () => {
  const user = useSelector(selectUser);
  const isSuperAdmin = useSelector(isSuperAdminUserSelector);
  const isAdmin = useSelector(isAdminSelector);
  if (isSuperAdmin) {
    return <Redirect to={PATHS.admin.supplierGroups} />;
  } else if (user?.permissions?.routesList || user?.permissions?.routes?.list) {
    return <Redirect to={PATHS.routes.current} />;
  } else if (user?.permissions?.ordersList || user?.permissions?.orders?.list) {
    return <Redirect to={PATHS.orders.root} />;
  } else if (isAdmin) {
    return <Redirect to={PATHS.admin.accountDetails} />;
  }
  else if (
    !user?.permissions?.navbar?.show_master_data &&
    !user?.permissions?.customers?.list
  ) {
    return <Redirect to={PATHS.tours.root} />;
  }

  return <Redirect to={PATHS.customers.root} />;
};
